import {erpserver,erpplatserver,oaserver,attendanceserver} from '@/utils/baseUrl';
import {post} from '@/utils/request';
//排版管理---------------------------------------------------------------------

// 获取公司
export async function getCompanyList(params) {
    return post(oaserver+"/oacurrency/getCompanyList", params, true);
}
//排班信息
export async function scheduleList(params) {
    return post(oaserver+"/hrschedule/scheduleList", params, true)
};
//班次列表
export async function bcList(params) {
    return post(oaserver+"/hrschedule/bcList", params, true)
};
//保存排班
export async function saveSchedule(params) {
    return post(oaserver+"/hrschedule/saveSchedule", params, true)
};
//排序
export async function sort(params) {
    return post(oaserver+"/hrschedule/sort", params, true)
};
//调班
export async function changeGroup(params) {
    return post(oaserver+"/hrschedule/changeGroup", params, true)
};
//日期复制排班
export async function duplicateSchedule(params) {
    return post(oaserver+"/hrschedule/duplicateSchedule", params, true)
};
//人员复制排班
export async function dupScheduleByPeople(params) {
    return post(oaserver+"/hrschedule/dupScheduleByPeople", params, true)
};
//录入产出外工时
export async function addPlanOverhaul(params) {
    return post(oaserver+"/hrschedule/addPlanOverhaul", params, true)
};
//部门
export async function getGroupList(params) {
    return post(oaserver+"/oacurrency/getGroupList", params, true)
};
//搜索框模糊查询
export async function searchUser(params) {
    return post(attendanceserver+'/attendence/searchUser', params, true)
}
//人员列表
export async function getPersonList(params) {
    return post(erpserver+'/currency/getPersonList', params, true)
}